import type { ResourceConfig } from "../types";

/**
 * 设计模板权限配置
 *
 * 查看权限: wp 课程学员（非 dropout）+ 管理角色
 * 管理权限: admin + coach + coach-manager
 */
export const designTemplateConfig = {
  displayName: "设计模板",
  category: "resource",
  permissions: {
    "read:all": {
      label: "查看设计模板",
      description: "可以浏览和下载设计模板",
    },
    "write:all": {
      label: "管理设计模板",
      description: "可以上传和删除设计模板",
    },
  },
  navigation: {
    path: "/design-templates",
    label: "设计模板",
    icon: "Palette",
    requiredPermissions: ["read:all"] as const,
    order: 70,
  },
} satisfies ResourceConfig;
